import mainFoods from "../data/mainFoods.json";

export const V2_MAIN_FOODS = Object.freeze(mainFoods.map((food) => Object.freeze({ ...food })));

export const V2_MAIN_FOOD_CATEGORIES = Object.freeze(
  Array.from(new Set(V2_MAIN_FOODS.map((food) => food.category).filter(Boolean))).sort((a, b) =>
    a.localeCompare(b)
  )
);

export function loadV2MainFoods() {
  return V2_MAIN_FOODS.filter((food) => food.active !== false);
}
